import { render, staticRenderFns } from "./ShowAsset.vue?vue&type=template&id=064fa493"
import script from "./ShowAsset.vue?vue&type=script&lang=js"
export * from "./ShowAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports